import { useState } from "react";
import DatePicker from "react-datepicker";
import SVG from "react-inlinesvg";
import {getYear, getMonth, subDays, format} from "date-fns"
import ConditionalRender from "app/common/components/ConditionalRender";
import CustomSelect from "app/common/components/CustomSelect";


const CustomDatePicker = ({selectsRange = false, calendarIcon = true, onChange, defaultValue, defaultToday, defaultThisWeek, medium, small, affix, isTime, ...props}) => {
    let defaultStart = defaultValue && new Date(selectsRange ? defaultValue?.split?.(" - ")?.[0] : (isTime ? `1970-01-01 ${defaultValue}` : defaultValue));
    if (defaultToday) defaultStart = new Date();
    if (defaultThisWeek) defaultStart = subDays(new Date(), new Date().getDay());

    let defaultEndDate = (defaultToday || defaultThisWeek || defaultValue) && new Date(defaultValue?.split?.(" - ")?.[1] || Date.now());
    const [startDate, setStartDate] = useState(defaultStart);
    const [endDate, setEndDate] = useState(defaultEndDate);

    const onCalendarClose = _ => {
        // Simulate Change Event
        const event = new Event('input', { bubbles: true });
        document.querySelector(`input[name="${props.name}"]`)?.dispatchEvent(event);
        // Set onChanges on hide calendar
        if (!selectsRange){
            if (!startDate) return;
            onChange?.(format(startDate, 'yyyy-MM-dd'));
            return;
        }
        if (!startDate || !endDate) return;
        onChange?.(`${format(startDate, 'yyyy-MM-dd')} - ${format(endDate, 'yyyy-MM-dd')}`);
    }

    const handleChange = (dates) => {
        if (!selectsRange){
            setStartDate(dates);
            return;
        }
        const [start, end] = dates;
        setStartDate(start);
        setEndDate(end);
        if (selectsRange && dates?.[0] === null &&  dates?.[1] === null){
            onChange?.(null);
        }
    };
    
    const years = Array(150).fill(1900).map((x, y) => x + y);
    const months = [
                        "January",
                        "February",
                        "March",
                        "April",
                        "May",
                        "June",
                        "July",
                        "August",
                        "September",
                        "October",
                        "November",
                        "December",
                    ];

    const customHeader =  ({date, changeYear, changeMonth, decreaseMonth, increaseMonth, prevMonthButtonDisabled, nextMonthButtonDisabled}) => {
        return  <div
                    className="flex m-3 space-x-3 text-sm font-medium leave-file-viewer-open"
                >
                    <select
                        className="bg-transparent drop-down-icon drop-down-edge w-[5.5rem] leave-file-viewer-open"
                        value={months[getMonth(date)]}
                        onChange={({ target: { value } }) =>
                        changeMonth(months.indexOf(value))
                        }
                    >
                        {months.map((option) => (
                        <option key={option} value={option} className="flex-1 leave-file-viewer-open">
                            {option}
                        </option>
                        ))}
                    </select>

                    <select
                        className="bg-transparent drop-down-icon drop-down-edge pr-4 leave-file-viewer-open"
                        value={getYear(date)}
                        onChange={({ target: { value } }) => changeYear(value)}
                    >
                        {years.map((option) => (
                        <option key={option} value={option} className="flex-1 leave-file-viewer-open">
                            {option}
                        </option>
                        ))}
                    </select>
                    <span className="flex-1 leave-file-viewer-open"></span>
                    <button onClick={decreaseMonth} disabled={prevMonthButtonDisabled} type="button" className="leave-file-viewer-open">
                        <SVG
                            src="/assets/media/svg/angle-left.svg"
                            className="stroke-current inline-block mx-0.5 w-1.5 leave-file-viewer-open"
                        />
                    </button>
                    <button onClick={increaseMonth} disabled={nextMonthButtonDisabled} type="button" className="leave-file-viewer-open">
                        <SVG
                            src="/assets/media/svg/angle-right.svg"
                            className="stroke-current inline-block mx-0.5 w-1.5 leave-file-viewer-open"
                        />
                    </button>
                </div>
    }
    return <div className="relative">
                <DatePicker 
                    selected={startDate}
                    startDate={startDate}
                    endDate={endDate}
                    selectsRange={selectsRange}
                    className={`form-input drop-down-icon ${!isTime && "pl-12"} cursor-pointer ${selectsRange && "min-w-[18rem]"} ${(medium || small) && "py-2"}`}
                    dateFormat={isTime ? "hh:mm" : "dd-MM-yyyy"}
                    placeholderText={props.placeholder ?? (isTime ? "HH:MM" : (selectsRange ? "DD-MM-YYYY - DD-MM-YYYY" : "DD-MM-YYYY"))}
                    showTimeSelect={isTime}
                    showTimeSelectOnly={isTime}
                    showTimeCaption={false}
                    timeCaption=""
                    timeFormat="hh:mm"
                    {...props}
                    onChange={handleChange}
                    renderCustomHeader={customHeader}
                    onCalendarClose={onCalendarClose}
                /> 
                <ConditionalRender
                    render={calendarIcon && !isTime}
                >
                    <div className={`absolute inline-block leave-file-viewer-open left-4 border-r pr-1.5 dark:border-dark ${small ? "top-[0.8rem]" : (medium ? "top-[1.1rem]" : "top-[1.3rem]")}`}>
                        <SVG
                            src="/assets/media/svg/calendar.svg"
                            className="fill-current inline-block text-grey-3 dark:text-dark-2 w-5 leave-file-viewer-open"
                        />
                    </div>
                </ConditionalRender>
                <ConditionalRender
                    render={affix}
                >
                    <div className={`absolute inline-block font-medium right-4 ${small ? "top-[0.8rem]" : (medium ? "top-[1.1rem]" : "top-[1.3rem]")}`}>
                        {affix}
                    </div>
                </ConditionalRender>
                <ConditionalRender
                    render={isTime}
                >
                    <div className={`absolute font-normal inline-block pl-2 right-0 top-[0.5rem]`}>
                        <CustomSelect
                            data={["AM", "PM"]}
                            defaultSelect={defaultStart?.getHours?.() >= 12 ? "PM" : "AM"}
                            name="amOrPm"
                            className={"pr-9 py-4"}
                            formatSelected={val => <span className="border-l dark:border-dark py-1 pl-2.5" >{val}</span>}
                        />
                    </div>
                </ConditionalRender>
            </div>
}

export default CustomDatePicker;